/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Link, useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import { Dropdown } from './style'
import { useProvider } from '../../provider/Provider'
import { Button } from '../button'
import { setAuthenticated } from '../../provider/actions'
import api from '../../services/api'

export default function UserDropdown() {
    const { authenticated, usuario, dispatch } = useProvider()
    const history = useHistory()

    if (!authenticated) {
        return (
            <li className="nav-item mx-2">
                <Link to="/login" id="idLogin">
                    <Button>Login</Button>
                </Link>
            </li>
        )
    }

    const logout = () => {
        swal('Deseja realmente sair?', {
            dangerMode: true,
            buttons: ['Cancelar', 'Sair']
        }).then((value) => {
            if (value) {
                localStorage.removeItem('token')
                setAuthenticated(dispatch, false)
                api.defaults.headers.common.Authorization = ''
                history.push('/')
            }
        })
    }

    const goToPerfil = () => {
        history.push('/perfil')
    }

    const goToMinhasEmpresas = () => {
        history.push('/MinhasEmpresas')
    }

    return (
        <Dropdown>
            <div className="dropdown-header">
                <div><i className="fas fa-user mx-3 fa-sm" /></div>
                <span>{usuario?.firstName}</span>
                <i className="fas fa-angle-down fa-lg mx-2" />
            </div>
            <div className="dropdown-body">
                <span onClick={goToMinhasEmpresas}>Minhas empresas</span>
                <span onClick={goToPerfil}>Meu perfil</span>
                <span onClick={logout}>Sair</span>
            </div>
        </Dropdown>
    )
}
